import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import { SET_GLOBAL_BANK_LIST } from 'state/actionTypes';

const banks = createReducer([], {
  [SET_GLOBAL_BANK_LIST]: (state, { payload }) => payload.banks,
});

export default combineReducers({
  banks,
});
